import { render, staticRenderFns } from "./SubscriptionHistoryList.vue?vue&type=template&id=19aa266b&scoped=true"
import script from "./SubscriptionHistoryList.vue?vue&type=script&lang=js"
export * from "./SubscriptionHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa266b",
  null
  
)

export default component.exports